import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Header";
import { useNavigate } from "react-router-dom";
import AgentNavBar from "./AgentNavBar";

const Properties_agent = () => {

    const [categories, setCategories] = useState([]);
    const [properties, setProperties] = useState([]);
    const [filtered, setFiltered] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState("All");
    const [search, setSearch] = useState("");
    const [price, setPrice] = useState(10000000);
    const [maxPrice, setMaxPrice] = useState(10000000);

    const [highways, setHighways] = useState([]);
    const [selectedHighway, setSelectedHighway] = useState("All");
    const [sortOrder, setSortOrder] = useState("default");

    const [filterOpen, setFilterOpen] = useState(false);

    const [layoutApprovals, setLayoutApprovals] = useState([]);
const [selectedLayoutApproval, setSelectedLayoutApproval] = useState("All");


    const [selectedNearby, setSelectedNearby] = useState("All");
    const [selectedPropertyType, setSelectedPropertyType] = useState("All");

    const nearbyOptions = [
        "IRR Inner Ring Road",
        "ORR Outer Ring Road",
        "RRR Regional Ring Road"
    ];

    const propertyTypeOptions = [
        "Open Plots/Villa Plots",
        "Flats",
        "Villas",
        "Farm Land",
        "Houses"
    ];

    
    /* ---------------- FETCH DATA ---------------- */

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {

        try {

            const [catRes, propRes, layoutRes] = await Promise.all([
                axios.get("https://api.propertygalleria.in/api/property-categories"),
                axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
                 axios.get("https://api.propertygalleria.in/master/api/api/layout-approvals")
                
            ]);
            const props = propRes.data.data;
            setCategories(catRes.data);
            // setProperties(propRes.data.data);
            // setFiltered(propRes.data.data);
            setProperties(props);
            setFiltered(props);

            /* GET UNIQUE HIGHWAYS */

            const uniqueHighways = [
                ...new Set(props.map(p => p.zone_desc).filter(Boolean))
            ];

            setHighways(uniqueHighways);
setLayoutApprovals(layoutRes.data.data);
            const highest = Math.max(
                ...props.map(p => parseInt(p.price) || 0)
            );

            setMaxPrice(highest);
            setPrice(highest);


        } catch (err) {
            console.log(err);
        }

    };

    const formatPrice = (num) => {

        if (num >= 10000000) {
            return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
        }

        if (num >= 100000) {
            return (num / 100000).toFixed(1).replace(".0", "") + "L";
        }

        if (num >= 1000) {
            return (num / 1000).toFixed(1).replace(".0", "") + "K";
        }

        return num;
    };

    /* ---------------- FILTER LOGIC ---------------- */

    // useEffect(() => {

    //     let data = [...properties];

    //     if (selectedCategory !== "All") {
    //         data = data.filter(
    //             p => p.category?.toLowerCase() === selectedCategory.toLowerCase()
    //         );
    //     }

    //     if (search) {
    //         data = data.filter(
    //             p => p.title?.toLowerCase().includes(search.toLowerCase())
    //         );
    //     }

    //     data = data.filter(p => parseInt(p.price) <= price);

    //     setFiltered(data);

    // }, [selectedCategory, search, price, properties]);


    useEffect(() => {

        let data = [...properties];

        /* CATEGORY FILTER */

        if (selectedCategory !== "All") {
            data = data.filter(
                p => p.category?.toLowerCase() === selectedCategory.toLowerCase()
            );
        }

        /* SEARCH FILTER */

        if (search) {
            data = data.filter(
                p =>
                    p.title?.toLowerCase().includes(search.toLowerCase()) ||
                    p.location?.toLowerCase().includes(search.toLowerCase())
            );
        }

        /* HIGHWAY FILTER */

        if (selectedHighway !== "All") {
            data = data.filter(
                p => p.zone_desc?.toLowerCase() === selectedHighway.toLowerCase()
            );
        }

               /* NEARBY FILTER */
        if (selectedNearby !== "All") {
            data = data.filter(
                p =>
                    p.nearby?.toLowerCase().trim() ===
                    selectedNearby.toLowerCase().trim()
            );
        }


             /* PROPERTY TYPE FILTER */
        if (selectedPropertyType !== "All") {
            data = data.filter(
                p =>
                    p.property_type?.toLowerCase().trim() ===
                    selectedPropertyType.toLowerCase().trim()
            );
        }
/* LAYOUT APPROVAL FILTER */

if (selectedLayoutApproval !== "All") {
    data = data.filter(
        p =>
            p.layout_approval?.toLowerCase().trim() ===
            selectedLayoutApproval.toLowerCase().trim()
    );
}
        /* PRICE FILTER */

        data = data.filter(
            p => parseInt(p.price) <= price
        );

        /* SORTING */

        if (sortOrder === "low") {
            data.sort((a, b) => parseInt(a.price) - parseInt(b.price));
        }

        if (sortOrder === "high") {
            data.sort((a, b) => parseInt(b.price) - parseInt(a.price));
        }

        setFiltered(data);

    }, [
        // selectedCategory,
        // selectedHighway,
        // selectedLayoutApproval,
        // search,
        // price,
        // sortOrder,
        // properties
           selectedCategory,
        selectedHighway,
        selectedNearby,
        selectedPropertyType,
        selectedLayoutApproval,
        search,
        price,
        sortOrder,
        properties
    ]);


    const navigate = useNavigate();

    return (
        <>
              <AgentNavBar/>

            {/* ---------------- CATEGORY SCROLL ---------------- */}

            <div style={categoryBar}>

                <button
                    style={selectedCategory === "All" ? activeCat : catBtn}
                    onClick={() => setSelectedCategory("All")}
                >
                    All
                </button>

                {categories.map(cat => (
                    <button
                        key={cat.id}
                        style={
                            selectedCategory === cat.category_name
                                ? activeCat
                                : catBtn
                        }
                        onClick={() => setSelectedCategory(cat.category_name)}
                    >
                        {cat.category_name}
                    </button>
                ))}

            </div>



            {/* ---------------- MAIN LAYOUT ---------------- */}

            <div style={layout}>


                {/* ---------------- LEFT FILTERS ---------------- */}

                <div style={filterBox}>

                    <h3 style={{ marginBottom: 20 }}>Filters</h3>

                    <label>Search</label>

                    <input
                        style={input}
                        placeholder="Search property..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <label>Category</label>

                    <select
                        style={input}
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >

                        <option value="All">All</option>

                        {categories.map(cat => (
                            <option key={cat.id}>
                                {cat.category_name}
                            </option>
                        ))}

                    </select>

                    <label>Highway</label>

                    <select
                        style={input}
                        value={selectedHighway}
                        onChange={(e) => setSelectedHighway(e.target.value)}
                    >
                        <option value="All">All</option>

                        {highways.map((hw, i) => (
                            <option key={i} value={hw}>
                                {hw}
                            </option>
                        ))}
                    </select>
                            {/* NEAR BY */}
                    <select
                        style={input}
                        value={selectedNearby}
                        onChange={(e) => setSelectedNearby(e.target.value)}
                    >
                        <option value="All">Select Ring Road</option>

                        <option value="IRR Inner Ring Road">
                            IRR Inner Ring Road
                        </option>

                        <option value="ORR Outer Ring Road">
                            ORR Outer Ring Road
                        </option>

                        <option value="RRR Regional Ring Road">
                            RRR Regional Ring Road
                        </option>
                    </select>
                    {/* PROPERTY TYPE */}
                    <select
                        style={input}
                        value={selectedPropertyType}
                        onChange={(e) => setSelectedPropertyType(e.target.value)}
                    >
                        <option value="All">Select Property Type</option>

                        <option value="Open Plots/Villa Plots">
                            Open Plots/Villa Plots
                        </option>

                        <option value="Flats">
                            Flats
                        </option>

                        <option value="Villas">
                            Villas
                        </option>

                        <option value="Farm Land">
                            Farm Land
                        </option>

                        <option value="Houses">
                            Houses
                        </option>
                    </select>
                   {/* LAYOUT APPROVAL */}
<select
    style={input}
    value={selectedLayoutApproval}
    onChange={(e) => setSelectedLayoutApproval(e.target.value)}
>
    <option value="All">All Layouts</option>

    {layoutApprovals.map((layout) => (
        <option
            key={layout.id}
            value={layout.approval_name}
        >
            {layout.approval_name}
        </option>
    ))}
</select>

                    <label>Price</label>

                    <input
                        type="range"
                        min="0"
                        max={maxPrice}
                        value={price}
                        onChange={(e) => setPrice(Number(e.target.value))}
                    /> 

                    <p>
                        Max Price : ₹ {formatPrice(price)}
                    </p>
                    <label style={{marginTop:'10px'}}>Sort By Price</label>

                    <select
                        style={input}
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                    >
                        <option value="default">Default</option>
                        <option value="low">Low → High</option>
                        <option value="high">High → Low</option>
                    </select>

                </div>


                {/* ---------------- PROPERTY GRID ---------------- */}

                <div style={propertyGrid}>

                    {filtered.map(p => (

                        <div key={p.id} style={card}>

                            <img
                                src={p.image || p.property_images?.[0]}
                                alt=""
                                style={image}
                                onClick={() =>
                                    navigate(`/properties/${p.id}`, {
                                        state: { property: p }
                                    })
                                }
                            />

                            <div style={{ padding: 15 }}>

                                <h3>{p.title}</h3>

                                <p style={{ color: "#666" }}>
                                    📍 {p.location}
                                </p>

                                <div style={priceRow}>
                                    <span style={{ color: "#2563eb", fontWeight: "bold" }}>
                                        {/* ₹ {p.price} */ } ₹ {formatPrice(p.price)}
                                    </span>

                                    <span>{p.area} ACRES</span>
                                </div>

                                <span style={badge}>
                                    {p.category}
                                </span>

                            </div>

                        </div>

                    ))}

                </div>


            </div>



            {/* <Footer/> */}
        </>
    );
};

export default Properties_agent;



/* ---------------- STYLES ---------------- */

const layout = {
    display: "flex",
    gap: 30,
    padding: "30px",
    alignItems: "flex-start"
};

const filterBox = {
    width: "260px",
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
    position: "sticky",
    top: 100
};

const propertyGrid = {
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))",
    gap: 20
};

const card = {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    transition: "0.3s"
};

const image = {
    width: "100%",
    height: 180,
    objectFit: "contain"
};

const categoryBar = {
    display: "flex",
    gap: 10,
    overflowX: "auto",
    padding: "20px 30px",
    borderBottom: "1px solid #eee"
};

const catBtn = {
    padding: "8px 18px",
    borderRadius: 20,
    border: "1px solid #ddd",
    background: "#fff",
    cursor: "pointer",
    whiteSpace: "nowrap"
};

const activeCat = {
    ...catBtn,
    background: "#2563eb",
    color: "#fff",
    border: "none"
};

const input = {
    width: "100%",
    padding: "10px",
    marginTop: 5,
    marginBottom: 15,
    borderRadius: 8,
    border: "1px solid #ddd"
};

const priceRow = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10
};

const badge = {
    marginTop: 10,
    display: "inline-block",
    background: "#e0ecff",
    color: "#2563eb",
    padding: "6px 12px",
    borderRadius: 20,
    fontSize: 12
};